import React from 'react';
import './Home.css';

const Home = () => (
  <div className="Home">
    <div className="cover" />
    <blockquote>
      <p>
        やってみて「ダメだ」と、わかった事と<br />
        はじめから「ダメだ」と、言われたことは 違います。
      </p>
      <footer><cite>イチロー</cite></footer>
    </blockquote>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js